module.exports = __webpack_public_path__ + "img/writingSeminar_041022_G.21c2b5b1.jpg";